export default __webpack_public_path__ + "static/media/citation-open.bf374d5a.svg";